module.exports = __webpack_public_path__ + "img/in-work1.3d8fb61e.gif";